export default "__VITE_ASSET__37acde88__"